module.exports = __webpack_public_path__ + "static/media/Flow-Chart-EG-M30.c4a7d6f4.jpg";